import React, { PureComponent } from 'react'
import { keyBy, map } from 'lodash'
import { startsWith } from 'lodash'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Header from '../components/Header'
import Footer from '../components/Footer'
import ModalCloudDetail from '../components/ModalCloudDetail'
import 'bootstrap/dist/css/bootstrap.css'
import 'font-awesome/css/font-awesome.css'
import './index.css'

class TemplateWrapper extends PureComponent {
  previousLocation = this.props.location
  state = {
    clouds: { names: [], byName: {} },
  }

  getChildContext() {
    return {
      setClouds: cloudsList => this.setState({
        clouds: {
          names: map(cloudsList, 'name'),
          byName: keyBy(cloudsList, 'name'),
        }
      })
    }
  }

  componentWillUpdate(nextProps) {
    const { location } = this.props
    // set previousLocation if props.location is not modal
    if (
      nextProps.history.action !== 'POP' &&
      (!location.state || !location.state.modal)
    ) {
      this.previousLocation = this.props.location
    }
  }

  closeModal = () => {
    this.props.history.push('/')
  }

  getCurrentCloudName = () => this.props.location.pathname.split('/')[2]

  goPrev = () => {
    const { clouds } = this.state
    const prevCloud = clouds.names[clouds.names.indexOf(this.getCurrentCloudName()) - 1]
    this.props.history.push({ pathname: `/cloud/${prevCloud}`, state: { modal: true } })
  }

  goNext = () => {
    const { clouds } = this.state
    const nextCloud = clouds.names[clouds.names.indexOf(this.getCurrentCloudName()) + 1]
    this.props.history.push({ pathname: `/cloud/${nextCloud}`, state: { modal: true } })
  }

  hasPrev = () => {
    const { clouds } = this.state
    return clouds.names.indexOf(this.getCurrentCloudName()) > 0
  }

  hasNext = () => {
    const { clouds } = this.state
    return clouds.names.indexOf(this.getCurrentCloudName()) < clouds.names.length -1
  }


  render() {
    const { location,
            children,
            match,
            twitterShareLink,
            googlePlusShareLink,
            facebookShareLink } = this.props

    const isModal = !!(
      location.state &&
      location.state.modal &&
      this.previousLocation !== location // not initial render
    )

    // Get modal cloud
    let cloud
    if (isModal) {
      const cloudName = this.getCurrentCloudName()
      cloud = this.state.clouds.byName[cloudName]
    }

    const downloadUrl =  cloud && `/dailyclouds/${cloud.name}/${cloud.name}.image.png`
    const shareUrl = `http://dailyclouds.inmagik.com${this.props.location.pathname}`;

    return (
      <div id='main'>
        <Helmet
          title="Daily clouds - by INMAGIK"
          meta={[
            // TODO: Replace \w something real...
            // { name: 'description', content: 'Sample' },
            // { name: 'keywords', content: 'sample, something' },
          ]}
        />
        <div className="layout">
          <div className="container">
            <Header />
            <div className="layout-content">
              {isModal
                ? children({
                  ...this.props,
                  location: this.previousLocation
                })
                : children()}
            </div>
              <ModalCloudDetail
                cloud={cloud}
                isOpen={isModal}
                onRequestClose={this.closeModal}
                goPrev={this.goPrev}
                goNext={this.goNext}
                hasPrev={this.hasPrev()}
                hasNext={this.hasNext()}
                downloadClick={downloadUrl}
                facebookShareLink={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
                twitterShareLink={`https://twitter.com/home?status=http%3A//dailyclouds.inmagik.com${this.props.location.pathname}`}
              />

          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

TemplateWrapper.childContextTypes = {
  setClouds: PropTypes.func,
}

//Modal.setAppElement('#main')

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js